module.exports = __webpack_public_path__ + "img/img_afq@2x.7041a2c7.png";